// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  added intermediate repo search table
// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  add intermediate repo field API integration
// kavyareddy 01/13/2023 2701306337 ,2701326866 createdDate added in payload
// kavyareddy 01/13/2023 2701306337 ,2701326866 Added newRepoName column
// Sohel 01/13/2023 2698964415 added created By and created For columns
// sai krishna 02/02/2023 2698964415 added repositorytype column and changed payload
// Ravi 02/06/2023 2698964415 changed title's First word from small to capital
// Dilip 02/09/2023 2698964415 added created by dropdown
// suresh peddavoora 02/21/2023 2698964415 table and textfields alignments
// Ravi 03/06/2023 2698964415 comment Add Field Button
// Akhila 06/08/2023 2698964415 created date change to date created field and column

import {Grid, TablePagination} from '@material-ui/core';
import React, {createRef, useEffect, useState} from 'react';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import {useDispatch} from 'react-redux';
import moment from 'moment-timezone';
import {httpPaginationPost} from '../../../util/Rest';
import {useSelector} from 'react-redux';
const IntermediateRepoSearchTable = ({
  searchData,
  submit,
  setSubmit,
  setOpen,
  mapFields,
  isDataManager,
  tempSelectedRows,
  handleDialogClose,
  setTempSelectedRows,
  setDMFieldValue,
  dmValues,
  dmArrayHelpers,
  deletedIds,
  setDeletedIds,
  tempUnCheckedRef,
  isProcessorFieldsMap,
}) => {
  const tableRef = createRef();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();

  const {status} = useSelector(({intermediateRepo}) => intermediateRepo);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    setTempSelectedRows && setTempSelectedRows([]);
    tempUnCheckedRef.current = [];
  }, []);

  useEffect(() => {
    if (status === 200) {
      tableRef?.current?.onQueryChange();
    }
  }, [status]);

  return (
    <Grid item xs={12}>
      <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table new-standard-textfields tablescroll-block ">
        <GuiTable
          title={''}
          columns={[
            {
              field: 'dmType',
              title: 'Type',
            },
            {
              field: 'nbRepoName',
              title: 'New Repository Name',
            },
            {
              field: 'nbFieldName',
              title: 'New Field Name',
            },

            {
              field: 'repoName',
              title: 'Repository Name',
            },
            {
              title: 'Repository Type',
              field: 'repositoryType',
              // maxWidth: 100,
              // render: (rowData) => {
              //   return rowData?.repositoryType?.toUpperCase() === "SYSTEM"
              //     ? "S - SYSTEM"
              //     : rowData?.repositoryType?.toUpperCase() === "USER"
              //     ? "U - USER"
              //     : "";
              // },
            },
            {
              field: 'fieldName',
              title: 'Field Name',
            },
            {
              field: 'repoType',
              title: 'Field Type',
            },
            {
              title: 'Created By',
              field: 'createdBy',
              // maxWidth: 150,
            },
            {
              title: 'Date Created',
              field: 'createdDate',
              // maxWidth: 90,
              render: (rowData) => {
                return rowData?.createdDate ?
                  moment(rowData?.createdDate).format('MM/DD/YYYY') :
                  '';
              },
            },
          ]}
          icons={tableIcons}
          tableRef={tableRef}
          // isLoading={isLoading}

          data={(query) =>
            new Promise((resolve) => {
              const url = `nbdatarepofields/search/all`;
              const bodyObj = {
                limit: query?.pageSize ? query?.pageSize : null,
                fieldName: searchData?.fieldName ? searchData?.fieldName : '',
                repoName: searchData?.repostoryName ? searchData?.repostoryName : '',

                nbFieldName: searchData?.newFieldName ? searchData?.newFieldName : '',
                dmType: searchData?.type ? searchData?.type : '',
                orderDirection: query?.orderDirection ? query?.orderDirection : '',
                orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                createdBy: searchData?.createdBy?.userLoginName ?
                  searchData?.createdBy?.userLoginName :
                  '',
                createdDate: searchData?.createdDate ?
                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                  '',
                nbRepoName: searchData?.nbRepoName ? searchData?.nbRepoName : '',
                repoType: searchData?.fieldType ? searchData?.fieldType : '',
                repositoryType: searchData?.repoType?.repoTypeName ?
                  searchData?.repoType?.repoTypeName :
                  '',
                page: submit ?
                  1 :
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!searchData) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 0,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;
                      const newObj = {};
                      if (isDataManager) {
                        if (dmValues) {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                              newObj[el.fieldName + el.repositoryName + 'tabType'] = el.tabType;
                            }
                          });
                        }
                      }
                      const newRows = data?.map((elem) => {
                        if (newObj[elem.nbFieldName + elem.nbRepoName]) {
                          return {
                            ...elem,
                            tabType: newObj[elem.nbFieldName + elem.nbRepoName + 'tabType'],
                            tableData: {...elem.tableData, checked: true},
                          };
                        } else {
                          return {
                            ...elem,
                            tableData: {...elem.tableData, checked: false},
                          };
                        }
                      });
                      resolve({
                        data:
                          isDataManager && newRows?.length > 0 ?
                            newRows :
                            data.length > 0 ?
                              data :
                              [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(data.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          onSelectionChange={(rows, row) => {
            if (row?.tableData?.checked) {
              if (isDataManager) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  if (isProcessorFieldsMap) {
                    arr.push({
                      ...row,
                      tableData: {...row.tableData, id: row.nbRepoName + row.nbFieldName},
                      processorFieldType: 'DB Field',
                      fieldHeader: row.nbFieldName,
                      fieldName: row.nbFieldName,
                      repositoryName: row.nbRepoName,
                      dataType: row.repoType,
                    });
                  } else {
                    arr.push({
                      ...row,
                      tableData: {...row.tableData, id: row.fieldName + row.repositoryName},
                      mapFieldType: 'DB Field',
                      fieldHeader: row.nbFieldName,
                      fieldName: row.nbFieldName,
                      fieldPosition: '',
                      startPosition: '',
                      fieldLength: '',
                      format: '',
                      repositoryName: row.nbRepoName,
                      dataType: row.repoType,
                    });
                  }
                  setTempSelectedRows(arr);
                }
              }
            } else {
              if (isDataManager) {
                tempUnCheckedRef.current.push(row);
                if (isProcessorFieldsMap) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !== row?.nbFieldName + row?.nbRepoName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {...ele.tableData, id: ele.fieldName + ele?.repositoryName},
                      };
                    });
                  setTempSelectedRows(updatedRows);
                } else {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {...ele.tableData, id: ele.fieldName + ele?.repositoryName},
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
              }
            }
          }}
          // actions={[
          //   {
          //     icon: () => (
          //       <>
          //         <Button
          //           type="button"
          //           variant="outlined"
          //           onClick={() => {
          //             setOpen(true);
          //           }}
          //           className={`mx-1 search-btn`}
          //         >
          //           Add Field
          //         </Button>
          //       </>
          //     ),
          //     isFreeAction: true,
          //     onClick: (event) => {},
          //   },
          // ]}
          options={{
            search: false,
            toolbar: !mapFields,
            pageSize: rows,
            toolbarButtonAlignment: 'left',
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            showTextRowsSelected: false,
            selection: mapFields,
            selectionProps: (rowData) => {
              return {
                disabled: isProcessorFieldsMap && rowData['tabType'] === 'Record Format Field',
              };
            },
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              // Added Download Configuration Buttons in Table Pagination (2700799562)
              <div className="global-field-table-footer ">
                <div></div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
          }}
        />
      </div>
      {/* {(errorMsg || deleteErrorMsg || printusage?.errorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg} />
      )}
      {(successMsg || printusage?.successMsg || tstmsg) && (
        <SuccessSnackbar successMsg={successMsg || printusage?.successMsg || tstmsg} />
      )} */}
    </Grid>
  );
};

export default IntermediateRepoSearchTable;
